/**
 * Module dependencies.
 */

import {
  Card,
  Image,
  ImageContainer,
  ProductDescription,
  Title,
} from './product.style';
import { JSX, ReactNode } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  description: string;
  imageSrc: string;
  title: string;
};

/**
 * Export `Product` component.
 */

export function Product(props: Props): JSX.Element {
  const { description, imageSrc, title } = props;

  return (
    <Card>
      <ImageContainer>
        <Image alt={title} src={imageSrc} />
      </ImageContainer>

      <div>
        <Title>{title}</Title>

        <ProductDescription>{description}</ProductDescription>
      </div>
    </Card>
  );
}
